<template>
  <div class="learn-ability-test-result-card-page">
    <img class="learn-ability-test-result-card-page-result-card"
         :src="resultImg"
         alt=""
    />
    <div class="learn-ability-test-result-card-page-action-block">
      <div class="learn-ability-test-result-card-page-save-hint">
        <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/card_arrow.png')"
             alt=""
        />
        <span>长按图片可保存测评报告</span>
        <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/card_arrow.png')"
             alt=""
        />
      </div>
      <div class="learn-ability-test-result-card-page-action-bar">
        <div class="learn-ability-test-result-card-page-action-btn"
             @click="handleTestAgain"
             v-ym-report:MARKETING_LEARNABILITYTEST_RETRY_CLICK=""
        >
          再测一次
        </div>
        <div class="learn-ability-test-result-card-page-action-btn primary"
             @click="handleToLearnPlan"
             v-ym-report:MARKETING_LEARNABILITYTEST_PLAN_CLICK=""
        >
          学习力提升计划
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { locationHref } from '@/utils';

  export default {
    name: 'LearnAbilityTestResultCardPage',
    props: {
      resultImg: {
        type: String,
        required: true,
      },
    },
    methods: {
      handleTestAgain() {
        window.location.reload();
      },
      handleToLearnPlan() {
        locationHref('https://www.youthmba.com/s/3wGFCRt');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learn-ability-test-result-card-page {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 1750px;

    &-result-card {
      display: block;
      width: 100%;
      height: 100%;
    }

    &-action-block {
      box-sizing: border-box;
      position: absolute;
      z-index: 10;
      left: 0;
      bottom: 0;
      padding-bottom: 70px;
      width: 100%;
      height: 270px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background: #242648;
    }
    &-save-hint {
      margin-bottom: 32px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      color: #e8eaff;
      font-size: @font-size-base;
      line-height: 1;

      img {
        margin: 0 10px;
        display: block;
        width: 26px;
        height: 36px;
      }
    }
    &-action-bar {
      box-sizing: border-box;
      padding: 0 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-action-btn {
      width: 260px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #242648;
      font-size: 36px;
      font-weight: @font-weight-bold;
      background: linear-gradient(to bottom, #ffffff, #ebebff);
      box-shadow: 0 8px 12px 0 rgba(16, 18, 53, 0.4);
      border-radius: 50px;

      &.primary {
        margin-left: 40px;
        flex: 1;
        background: linear-gradient(0deg, #ffdf30, #fff176);
        box-shadow: 0 8px 12px 0 rgba(16, 18, 53, 0.4);
      }
    }
  }
</style>
